import ApplicationRecord from './ApplicationRecord';
export default class ImageRecord
  extends ApplicationRecord({
    /**
   * @type {String}
   */
    id: '#Image',

    /**
   * @type {String}
   */
    alt: '',

    /**
   * @type {Number}
   */
    width: 0,

    /**
   * @type {Number}
   */
    height: 0,

    /**
   * @type {Boolean}
   */
    isLandscape: false,

    /**
   * @type {Boolean}
   */
    isSquare: false,

    /**
   * @type {Boolean}
   */
    isPortrait: false,

    /**
   * @type {String}
   */
    desktop_src: '',

    /**
   * @type {String}
   */
    mobile_src: '',

    /**
     * @type {String}
     */
    href: '',
  }) {}



// WEBPACK FOOTER //
// ./src/models/ImageRecord.js